import React, { useState, useEffect, useContext, createContext } from "react"
import axios from 'axios'

const authContext = createContext()

export function ProvideAuth({ children }) {
  const auth = useProvideAuth()
  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

const getToken = () => {
  try {
    const tokenString = localStorage.getItem('token')
    const token = JSON.parse(tokenString)
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return token
  } catch (e) {
    return null
  }
}

// Provider hook that creates auth object and handles state
export function useProvideAuth() {
  const [token, setToken] = useState(getToken())
  const [user, setUser] = useState(null)
  const [error, setError] = useState(null)

  const saveToken = userToken => {
    localStorage.setItem('token', JSON.stringify(userToken))
    setToken(userToken)
  }

  const getUser = async (token) => {
    if (token) {
      try {
        const rsp = await axios.get('/api/users/me', { headers: {'Authorization': `Bearer ${token}`} })
        const user = rsp.data
        setUser({...user, permissions: user.permissions.split(',')})
      } catch (e) {
        const status = e.response.status
        if (status === 403 || status === 401) {
          saveToken(null)
          setUser(null)
        }
        setError(e)
        console.log(e)
      }
    }
    else setUser(null)
  }

  const signin = async (username, password, scopes, cb) => {
    let form = new FormData()
    form.append("grant_type", "password")
    form.append("username", username)
    form.append("password", password)
    form.append("scope", scopes.join(" "))
    let tokenResponse = null
    try {
      tokenResponse = await axios.post("/auth/jwt/login", form)
    } catch(error) {
      setError(error.response.data)
      return
    }
    const token = tokenResponse.data.access_token
    saveToken(token)
    await getUser(token)
    cb()
  }

  const signout = async (cb) => {
    saveToken(null)
    setUser(null)
    cb()
  }

  useEffect(() => {
    getUser(token)
  }, [token])

  useEffect(() => {
    // Put token in default authorization header
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      axios.interceptors.response.use((response) => {
        return response
      }, (error) => {
        //const status = error.response.status
        //if (status === 400 || status === 403 || status === 401) saveToken(null)
        return Promise.reject(error)
      })
    }
  }, [token])

  // Return the user object and auth methods
  return { user, token, error, signin, signout }
}

export function useAuth() {
  return useContext(authContext)
}
